import type {ReactElement} from 'react';
import {AiPromptBox} from '@Components/ai-prompt-box/ai-prompt-box';
import {PosterEditorTestId} from '@/test-ids/poster-editor-test-id';
import {getPromptBoxOptions} from '@Panels/ai-voice-panel/ai-voice-panel.library';
import {AiVoicePanelErrorState} from '@Panels/ai-voice-panel/ai-voice-panel.types';
import {GeneratedVoiceList} from '@Panels/ai-voice-panel/components/generated-voice-list';
import {DailyLimitError} from '@Panels/ai-voice-panel/components/daily-limit-error';
import type {AiVoiceViewProps} from './ai-voice-view.types';
import {VoiceProfilePills} from '@Panels/ai-voice-panel/components/voice-profile-pills';

export function AiVoiceView({
  panelId = '',
  isGenerating,
  errorState,
  selectedVoiceProfileId,
  onCTAClick,
  onAddAudioItem,
  onProfileSelected,
  getAiPromptBoxOptions,
  isFullScreen = false,
}: AiVoiceViewProps): ReactElement<HTMLDivElement> {
  return (
    <div className={`flex-v-row _full-height`}>
      <AiPromptBox
        id={panelId}
        inputTestId={PosterEditorTestId.AI_VOICE_PROMPT_INPUT}
        initialConfig={getPromptBoxOptions()}
        onGenerate={onCTAClick}
        onRegenerate={onCTAClick}
        options={[getAiPromptBoxOptions]}
      />
      <VoiceProfilePills selectedProfileId={selectedVoiceProfileId} onProfileSelected={onProfileSelected} isFullScreen={isFullScreen}/>
      <GeneratedVoiceList isGenerating={isGenerating} onAddAudioItem={onAddAudioItem} />
      {errorState === AiVoicePanelErrorState.DAILY_LIMIT_REACHED ? <DailyLimitError /> : null}
    </div>
  );
}
